import { render, staticRenderFns } from "./brugge.vue?vue&type=template&id=ff7675c8"
import script from "./brugge.vue?vue&type=script&lang=js"
export * from "./brugge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports